/**
 * Core types for Snap Pairs game
 */

export type TileSymbol = string;

export interface Position {
  row: number;
  col: number;
}

export interface Tile {
  id: string;
  symbol: TileSymbol;
  position: Position;
  matched: boolean;
}

export interface Board {
  tiles: Map<string, Tile>;
  gridSize: number;
}

export enum MovementMode {
  Static = 'static',
  CollapseColumns = 'collapse',
  CompressCenter = 'compress'
}

export enum GameStatus {
  NotStarted = 'not_started',
  Playing = 'playing',
  Paused = 'paused',
  GameOver = 'game_over',
  Won = 'won'
}

export interface GameState {
  board: Board;
  score: number;
  timeRemaining: number;
  status: GameStatus;
  selectedTile: Tile | null;
  movementMode: MovementMode;
  lastMatchTime: number;
  matchCount: number;
}

export interface GameConfig {
  gridSize: 4 | 6 | 8;
  roundDuration: number;
  movementMode: MovementMode;
  symbols: TileSymbol[];
  enableRegeneration?: boolean; // For infinity mode - regenerate tiles instead of removing them
}

export interface ScoreEvent {
  basePoints: number;
  comboBonus: number;
  clearBonus: number;
  total: number;
}

// Joker tile symbol - matches any other tile
export const JOKER_SYMBOL: TileSymbol = '🀟';

export const DEFAULT_SYMBOLS: TileSymbol[] = [
  '🀀', '🀁', '🀂', '🀃', '🀄', '🀅', '🀆', '🀇',
  '🀈', '🀉', '🀊', '🀋', '🀌', '🀍', '🀎', '🀏',
  '🀐', '🀑', '🀒', '🀓', '🀔', '🀕', '🀖', '🀗',
  '🀘', '🀙', '🀚', '🀛', '🀜', '🀝', '🀞', JOKER_SYMBOL
];
